import { AbstractPathResolver, PathResolveResult } from '../PathResolver';

export class UserProfilePathResolver extends AbstractPathResolver {
  resolveStateFromPath(): PathResolveResult {
    const { path } = this.context;
    if (path.startsWith('/@')) {
      const defaultState = this.getDefaultState({
        screens: {
          userProfile: this.context.options?.screens?.userProfile,
        },
      });

      // user profile.
      const username = path.substring(2).split('/')[0];
      return {
        index: 1,
        routes: [
          {
            name: 'home',
          },
          ...(defaultState?.routes ?? [
            {
              name: 'userProfile',
              params: { username },
            },
          ]),
        ],
      };
    }
  }
}
